import { memo } from 'react';

import {
  PrivateGalleryAsset,
  type PrivateGalleryAssetProps,
} from '~/components/v2/components/board/gallery/PrivateGalleryAsset';

export type PrivateBoardGalleryViewAssetProps = Omit<PrivateGalleryAssetProps, 'trackLocation' | 'ancestors'>;

export const PrivateBoardGalleryViewAsset = memo(({ box, data, index }: PrivateBoardGalleryViewAssetProps) => {
  return <PrivateGalleryAsset box={box} data={data} index={index} />;
});

PrivateBoardGalleryViewAsset.displayName = 'PrivateBoardGalleryViewAsset';
